import React, { useState } from 'react';
import Icon from '../../icon';
import { useTheme } from '../../theme/theming';
import Button from '../button';
import useDropdownStyles from './styles';

export default function Dropdown(props) {
  const theme = useTheme();
  const classes = useDropdownStyles(props);
  return (
    <div className={classes.container}>
      <div className={classes.label}>
        {props.label}{' '}
        <Icon
          name="Angle"
          className={classes.icon}
          color={theme.palette.primary.main}
          width="12px"
          height="12px"
        />
        {/* {props.label} <img src={props.icon} className={classes.icon} /> */}
      </div>
      <div className={classes.listBox}>
        {props?.list?.map((dt, ind) => {
          return (
            <Button
              key={ind}
              data={{
                link: dt.slug,
                isLink: true,
                value: dt.title,
                isExternal: 0
              }}
              fluid
              active={dt.active}
              type={'tertiary'}
              size={props.isMobile ? 'small' : 'medium'}
            />
          );
        })}
      </div>
    </div>
  );
}
